// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_3b14cd31"};